import React, { useState } from "react";
import {Link} from "react-router-dom";
import {Col, Modal} from "reactstrap";
import {getLoggedinUser} from "../../helpers/api_helper";
import Select from "react-select";
import {useOffice} from "../../hook/useOffice";

export const ModalSelectOffice = (props) => {
  const [selectedGroup2, setSelectedGroup2] = useState(null);

  const { selectOffice } = useOffice();

  const createData = () => {
    let data = getLoggedinUser().data ? getLoggedinUser().data.offices : [];
    return (data || []).map((item) => {
      return {
        value: item.office_id,
        label: item.name,
      };
    });
  };

  return (
    <Modal
      isOpen={props.isOpen}
      toggle={() => {
        props.toggle();
      }}
      zIndex={10000}
      backdrop={"static"}
      id="staticBackdrop"
      centered
    >
      <div className="modal-body p-5">
        <div className="text-center">
          <lord-icon
            src="https://cdn.lordicon.com/fhtaantg.json	"
            trigger="loop"
            colors="primary:#121331,secondary:#08a88a"
            style={{ width: "120px", height: "120px" }}
          ></lord-icon>
        </div>

        <div className="mt-4">
          <h4 className="mb-3">
            Olá,{" "}
            {getLoggedinUser().data ? getLoggedinUser().data.first_name : ""}!
          </h4>
          <p className="text-muted mb-4">
            {" "}
            Selecione um escritório para ver as informações dele.
          </p>
        </div>

        <Col md={12}>
          <div className="mb-3">
            <Select
              isClearable={true}
              placeholder="Selecione um escritório"
              value={selectedGroup2}
              options={createData() || []}
              onChange={(e) => {
                setSelectedGroup2(e);
              }}
              inputId="categoryPlanInput"
            />
          </div>
        </Col>

        <div className="hstack gap-2 justify-content-end">
          <Link
            to="#"
            className="btn btn-success"
            onClick={() => selectOffice(selectedGroup2.value)}
          >
            Pronto
          </Link>
        </div>
      </div>
    </Modal>
  );
};
